import { service } from "../utils/request";

// 设置微信配置信息
export function wechat_setConfig(data) {
  return service({
    url: "api/config.wechat/setConfig",
    method: "post",
    data: data
  });
}
// 获取微信配置信息
export function wechat_getConfig(data) {
  return service({
    url: "api/config.wechat/index",
    method: "post",
    data: data
  });
}
// 上传文件
export function uploadVerify(data) {
  return service({
    url: "api/upload/uploadVerify",
    method: "post",
    data: data
  });
}

// 二维码链接
export function SetEmpower(data) {
  return service({
    url: "wechat/agent.index/geturl",
    method: "post",
    data: data
  });
}
//支付宝商户授权
export function authorizeMerchat(data) {
  return service({
    url: "/aliyun/agent.index/authorizeMerchat",
    method: "post",
    data: data
  });
}


// 微信授权信息
export function GetEmpower(data) {
  return service({
    url: "wechat/agent.index/config",
    method: "post",
    data: data
  });
}
// 支付宝小程序授权
export function AliMiniConfig(data) {
  return service({
    url: "/aliyun/agent.index/miniAuthorize",
    method: "post",
    data: data
  });
}
// 获取支付宝小程序授权信息
export function GetAliMiniConfigInfo(data) {
  return service({
    url: "/aliyun/agent.index/config",
    method: "post",
    data: data
  });
}
// 取消支付宝授权信息
export function setAliMiniConfigInfo(data) {
  return service({
		url: "/aliyun/agent.index/cancelAuth",
		method: "post",
		data: data,
	});
}

// 获取底部菜单
export function GetMenu(data) {
  return service({
    url: "wechat/agent.menu/getMenu",
    method: "post",
    data: data
  });
}

// 添加底部菜单
export function AddMenu(data) {
  return service({
    url: "wechat/agent.menu/addWeixinMenu",
    method: "post",
    data: data
  });
}

// 删除底部菜单
export function ClearMenu(data) {
  return service({
    url: "wechat/agent.menu/menuDel",
    method: "post",
    data: data
  });
}

// 获取小程序配置
export function GetMiniConfig(data) {
  return service({
    url: "wechat/agent.index/miniConfig",
    method: "post",
    data: data
  });
}
// 获取支付宝小程序信息
export function GetAliMiniSetInfo(data) {
  return service({
    url: "/aliyun/agent.index/info",
    method: "post",
    data: data
  });
}
// 小程序创建会员卡券
export function CreateMiniCard(data) {
  return service({
    url: "/wechat/agent.card/createMiniCard",
    method: "post",
    data: data
  });
}
// 小程序编辑会员卡
export function EditMiniCard(data) {
  return service({
    url: "/wechat/agent.card/createMiniCard",
    method: "post",
    data: data
  });
}